import { FC } from "react";
import { CivilCasePowerOfAgency, PowerOfAgency } from "types";

type Props = {
  powerOfAgency: CivilCasePowerOfAgency | undefined;
  isOpen: boolean;
  onClose: (refetch: boolean) => void;
};

const CivilCasePowerOfAgencyDetail: FC<Props> = ({
  powerOfAgency,
  isOpen,
  onClose,
}) => {
  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div
        className={`relative w-full bg-white p-8 shadow-lg rounded-lg overflow-y-auto max-w-2xl`}
      >
        <h2 className="text-[22px] font-semibold leading-7">
          {powerOfAgency?.name}
        </h2>
        <div className={`overflow-y-scroll overflow-x-hidden pr-5 w-full mb-4`}>
          {[
            { property: "Region", value: powerOfAgency?.region },
            { property: "Phone", value: powerOfAgency?.phone_number },
            { property: "Email", value: powerOfAgency?.email },
            { property: "Zone / City", value: powerOfAgency?.zone_or_city },
            { property: "Sub City", value: powerOfAgency?.sub_city },
            {
              property: "Woreda",
              value: powerOfAgency?.woreda_or_kebele,
            },
            { property: "Kebele", value: powerOfAgency?.kebele },
            { property: "House Number", value: powerOfAgency?.house_number },
          ]?.map((info, index) => (
            <div
              key={index}
              className="flex flex-row gap-4 mt-3 items-start justify-between border-b border-b-[#E9E9E9] pb-3"
            >
              <p className="font-normal text-base text-[#0A1D39]">
                {info?.property}
              </p>
              <p className="font-normal text-base text-[#0A1D39]">
                {typeof info?.value === "boolean" ||
                typeof info?.value === "object"
                  ? String(info?.value)
                  : info?.value}
              </p>
            </div>
          ))}
        </div>
        <div className="text-right mt-10">
          <input
            type="button"
            className="border border-[#212121] bg-[#212121] my-3 py-1 px-4 text-white  cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]"
            value={"Close"}
            onClick={() => onClose(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default CivilCasePowerOfAgencyDetail;
